import { Card, Checkbox, DatePicker, Form, Select } from "antd";
import React, { useEffect, useState } from "react";
import {
  updateDoc,
  doc,
  collection,
  getDocs,
  query,
  where,
} from "firebase/firestore";
import { db, auth } from "../../../../firebase";
import { useAuthState } from "react-firebase-hooks/auth";
import { toast } from "react-hot-toast";
import { tenantStatus } from "../../../../utils/tenants";
import FormAction from "../../../../components/common/FormAction";
import dayjs from "dayjs";

function TenantStatus({ data }) {
  const [checked, setChecked] = useState(false);
  const [user, loading] = useAuthState(auth);
  const [companyName, setcompanyName] = useState("");

  const currentDate = dayjs();

  const fetchCompanyName = async () => {
    try {
      const usersRef = collection(db, "allUsers");
      const userData = query(usersRef, where("uid", "==", user.uid));
      getDocs(userData)
        .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            const res = doc.data();
            setcompanyName(res.companyName);
          });
        })
        .catch((error) => {
          console.log("Error getting users: ", error);
        });
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    fetchCompanyName();
  }, [user, loading]);

  const onCancel = () => {
    setChecked(false);
  };

  const handleFormSubmit = (values) => {
    Object.keys(values).forEach((field) => {
      if (values[field] === undefined) {
        values[field] = "";
      }
    });

    const status = {
      "tenantStatus.tenantType": values.type,
      "tenantStatus.moveInDate": values.moveInDate.format("YYYY-MM-DD"),
      "tenantStatus.moveOutDate": values.moveOutDate
        ? values.moveOutDate.format("YYYY-MM-DD")
        : data?.tenantStatus?.moveOutDate,
      "tenantStatus.noticeDate": values.notice
        ? values.notice.format("YYYY-MM-DD")
        : data?.tenantStatus?.noticeDate,
      "tenantStatus.moveOutReason": values.moveOutReason,
      "tenantStatus.sendRentReminders": values.sendRentReminders,
      "tenantStatus.depositReturnViaEcheck": values.depositReturnViaEcheck,
    };

    try {
      const tenantRef = doc(db, "companies", companyName, "tenants", data?.id);
      updateDoc(tenantRef, status);
      setChecked(false);
      toast.success("Tenant Status updated successfully");
    } catch (error) {
      console.error("Error updating document:", error);
    }
  };

  const onFinishFailed = (errorInfo) => {
    toast.error("There are problems with one or more required fields");
    console.log("Failed:", errorInfo);
  };

  const initialValues = {
    type: data?.tenantStatus?.tenantType,
    moveInDate: data?.tenantStatus?.moveInDate
      ? dayjs(data?.tenantStatus?.moveInDate, "YYYY-MM-DD")
      : null,
    moveOutReason: data?.tenantStatus?.moveOutReason,
    sendRentReminders: data?.tenantStatus?.sendRentReminders,
    depositReturnViaEcheck: data?.tenantStatus?.depositReturnViaEcheck,
  };
  return (
    <Card
      title="Tenant Status"
      extra={
        !checked ? (
          <span className="onclick-text" onClick={() => setChecked(true)}>
            Edit
          </span>
        ) : null
      }
    >
      {checked ? (
        <Form
          colon={false}
          labelCol={{ span: 8 }}
          wrapperCol={{ span: 11 }}
          labelWrap={{ span: 8 }}
          initialValues={initialValues}
          onFinish={handleFormSubmit}
          onFinishFailed={onFinishFailed}
        >
          <Form.Item label="Type" name="type">
            <Select options={tenantStatus} placeholder="Select" />
          </Form.Item>
          <Form.Item
            label="Move In"
            required
            name="moveInDate"
            rules={[{ required: true, message: "Please enter move in date" }]}
          >
            <DatePicker style={{ width: "100%" }} />
          </Form.Item>
          <Form.Item label="Move Out" name="moveOutDate">
            <DatePicker style={{ width: "100%" }} />
          </Form.Item>
          <Form.Item label="Notice" name="notice">
            <DatePicker style={{ width: "100%" }} />
          </Form.Item>
          <Form.Item label="Move Out Reason" name="moveOutReason">
            <Select disabled />
          </Form.Item>
          <Form.Item
            label="Send Rent Reminders"
            name="sendRentReminders"
            valuePropName="checked"
          >
            <Checkbox
              checked={data?.tenantStatus?.sendRentReminders ? true : false}
              disabled
            >
              Why can't I change this?
            </Checkbox>
          </Form.Item>
          <Form.Item
            label="Security Deposit Return via eCheck"
            name="depositReturnViaEcheck"
            valuePropName="checked"
          >
            <Checkbox
              checked={
                data?.tenantStatus?.depositReturnViaEcheck ? true : false
              }
            ></Checkbox>
          </Form.Item>
          <FormAction cancel={onCancel} submit="submit" />
        </Form>
      ) : (
        <Form
          colon={false}
          labelCol={{ span: 8 }}
          wrapperCol={{ span: 11 }}
          labelWrap={{ span: 8 }}
        >
          <Form.Item label="Type">
            <p>
              {data?.tenantStatus?.tenantType
                ? data?.tenantStatus?.tenantType
                : "--"}
            </p>
          </Form.Item>
          <Form.Item label="Status">
            {currentDate.isSame(data?.tenantStatus?.moveInDate, "day") ||
            currentDate.isBefore(data?.tenantStatus?.moveInDate, "day")
              ? "future"
              : data?.tenantStatus?.moveOutDate
              ? "past"
              : "current"}
          </Form.Item>
          <Form.Item label="Move In">
            <p>
              {data?.tenantStatus?.moveInDate
                ? data?.tenantStatus?.moveInDate
                : "--"}
            </p>
          </Form.Item>
          <Form.Item label="Move Out">
            <p>
              {data?.tenantStatus?.moveOutDate
                ? data?.tenantStatus?.moveOutDate
                : "--"}
            </p>
          </Form.Item>
          <Form.Item label="Notice">
            <p>
              {data?.tenantStatus?.notice ? data?.tenantStatus?.notice : "--"}
            </p>
          </Form.Item>
          <Form.Item label="Move Out Reason">
            <p>
              {data?.tenantStatus?.moveOutReason
                ? data?.tenantStatus?.moveOutReason
                : "--"}
            </p>
          </Form.Item>
          <Form.Item label="Send Rent Reminders">
            <p>
              {data?.tenantStatus?.sendRentReminders
                ? data?.tenantStatus?.sendRentReminders
                : "--"}
            </p>
          </Form.Item>
          <Form.Item label="Security Deposit Return via eCheck">
            <p>
              {data?.tenantStatus?.depositReturnViaEcheck
                ? data?.tenantStatus?.depositReturnViaEcheck
                : "--"}
            </p>
          </Form.Item>
        </Form>
      )}
    </Card>
  );
}

export default TenantStatus;
